import React, { useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer2";
import offerImage1 from "../../assets/images/offers-img1.jpeg";
import offerLogo1 from "../../assets/images/offer-logo1.png";
import LocationIcon from "../../assets/images/location.svg";
import PhoneIcon from "../../assets/images/phone.svg";
import LineRightIcon from "../../assets/images/lineRigtharrow.svg";
import RupeeIcon from "../../assets/images/gold_rupe_icon.svg";
import RedeemIcon from "../../assets/images/redeem.svg";
import MapImage from "../../assets/images/mapimage.svg";
import BackIcon from "../../assets/images/LineWhiteArrow.svg";
import LineIcon from "../../assets/images/line.svg";

import { fetchTermsAndCondition } from "../../redux/slice/offers/rewards";
import { issueRewardCall } from "../../redux/slice/offers/issueRewards";
import { fetchRedemptionAllowance } from "../../redux/slice/offers/redemptionAllowance";
import { formatRewardCatalogueAmount } from "../../utils/common";
import {
  REDEMPTION_ALLOWANCE_COPY,
  findAllowanceGroup,
  getMonthlyLimitErrorMessage,
  hasMonthlyBrandLimitExceeded,
} from "../../utils/redemptionAllowance";
import Spinner from "../../component/spinner/Spinner";
import "./OfferPage.scss";

const OfferPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  let mobile = localStorage.getItem("mobile");
  const offer = location?.state || {};
  const { termsAndConditionData } = useSelector((state) => state.rewards);

  const { issueRewardData, loading: issueRewardLoading } = useSelector(
    (state) => state.issueReward
  );
  const redemptionAllowance = useSelector((state) => state.redemptionAllowance);
  const allowanceGroup = findAllowanceGroup(
    offer,
    redemptionAllowance?.groups
  );
  const [isRedirectionOn, setIsRedirectionOn] = useState(false);

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
    >
      Home
    </Link>,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
      onClick={() => navigate("/rewards-catalogue")}
    >
      Rewards Catalogue
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#1D1D1B",
      }}
    >
      {offer?.name}
    </Typography>,
  ];

  const handleIssueReward = async () => {
    const data = {
      mobile,
      transactionNumber: Date.now(),
      notes: `Redeemed points for ${offer?.name}`,
      brand: process.env.REACT_APP_BRAND || "DLFMallsDemo",
    };
    const result = await dispatch(
      issueRewardCall({ data, id: offer?.id, rewardName: offer?.name })
    );
    // console.log(result, "result");

    if (hasMonthlyBrandLimitExceeded(result?.payload)) {
      toast.error(getMonthlyLimitErrorMessage(redemptionAllowance));
      dispatch(fetchRedemptionAllowance());
      return;
    }

    if (result?.payload?.intouch && result?.payload?.intouch !== null) {
      toast.success("Reward issued successfully");
      setIsRedirectionOn(true);
    } else {
      toast.error("Reward issue failed");
    }
  };
  useEffect(() => {
    if (offer) {
      dispatch(fetchTermsAndCondition(offer?.termAndConditionsUrl));
    }
    dispatch(fetchRedemptionAllowance());
  }, [offer]);
  return (
    <div>
      <Header />
      <div className="parent-container">
        <div
          className="container in-mobile desktop_content"
          style={{ paddingBottom: "8px" }}
        >
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </div>
        <div className="container">
          <div className="page-container">
            <div
              style={{ backgroundImage: `url(${offer?.thumbnailUrl})` }}
              className="offer1"
            >
              <div
                className="mobile_content back-content"
                onClick={() => navigate(-1)}
              >
                <img src={BackIcon} alt="back icon" width={10} height={24} />
                <p>{offer?.name}</p>
              </div>
              <div className="gardient">
                <div className="points-container">
                  <div className="points1">
                    <img src={RupeeIcon} alt="rupee icon" />
                    <p>{formatRewardCatalogueAmount(offer?.intouchPoints)} Points</p>
                  </div>
                  <div className="points2">
                    <p className="with-span">
                      <span>Valid Till:</span>{" "}
                      {moment(offer?.endTime).format("DD MMM YYYY")}
                    </p>
                    <img
                      src={offer?.thumbnailUrl}
                      alt="logo"
                      className="logo"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="offer2">
              <div className="title-container">
                {/* <p className="title">{offer?.name}</p> */}
                <h4>{offer?.name}</h4>
                <div className="address-container">
                  <img
                    src={LocationIcon}
                    alt="Location icon"
                    width={22}
                    height={24}
                  />
                  <p style={{ textTransform: "capitalize" }}>
                    {offer?.categoryList?.[0]?.name || "N/A"}
                  </p>
                </div>
                {allowanceGroup?.remaining != null && (
                  <div className="allowance-headroom">
                    <p>
                      {REDEMPTION_ALLOWANCE_COPY.remaining(
                        allowanceGroup.remaining
                      )}
                    </p>
                  </div>
                )}
              </div>
              <div className="activate-container">
                <button
                  onClick={() => {
                    if (allowanceGroup?.blocked) return;
                    handleIssueReward();
                  }}
                  disabled={Boolean(allowanceGroup?.blocked) || issueRewardLoading}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  Activate Offer {issueRewardLoading ? <Spinner /> : null}
                </button>
                {/* <div className="img-container">
                  <div>
                    <img
                      src={PhoneIcon}
                      alt="phone icon"
                      width={19}
                      height={19}
                    />
                  </div>
                  <div>
                    <img
                      src={LineRightIcon}
                      alt="line right icon"
                      width={15}
                      height={15}
                    />
                  </div>
                </div> */}
              </div>
              {isRedirectionOn && (
                <p style={{ color: "#024D3E", marginTop: "10px" }}>
                  Reward Activated Successfully. Click
                  <span
                    onClick={() => {
                      sessionStorage.setItem("rediFromReward", true);
                      navigate("/rewards-catalogue");
                    }}
                    style={{
                      textDecoration: "underline",
                      fontWeight: "bold",
                      margin: "0 5px",
                      cursor: "pointer",
                    }}
                  >
                    here
                  </span>
                  to see
                </p>
              )}
              <div className="details-container">
                <Accordion
                  sx={{ backgroundColor: "#f7f3eb", boxShadow: "none", mb: 1 }}
                  defaultExpanded
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon color="error" />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ borderBottom: "1px solid #E4E4E4" }}
                  >
                    <h5>Offer detail</h5>
                  </AccordionSummary>
                  <AccordionDetails>
                    <p>{offer?.description}</p>
                    <span className="valid">
                      Valid Till: {moment(offer?.endTime).format("DD MMM YYYY")}
                    </span>
                  </AccordionDetails>
                </Accordion>

                {/* <Accordion
                  sx={{ backgroundColor: "#f7f3eb", boxShadow: "none", mb: 1 }}
                  className="directions"
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon color="error" />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ borderBottom: "1px solid #E4E4E4" }}
                  >
                    <h5>Store directions</h5>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{ paddingTop: "16px", paddingBottom: "16px" }}
                  >
                    <div className="directions-details">
                      <div
                        style={{
                          width: "300px",
                          height: "166px",
                          backgroundImage: `url(${MapImage})`,
                          backgroundSize: "cover",
                          margin: "0 auto 10px auto",
                        }}
                      ></div>
                      <div className="btn-container">
                        <button>
                          <img
                            src={PhoneIcon}
                            alt="phone icon"
                            width={15}
                            height={15}
                          />
                          <p>Call</p>
                        </button>
                        <button>
                          <img
                            src={LineRightIcon}
                            alt="line right icon"
                            width={15}
                            height={15}
                          />
                          <p>Direction</p>
                        </button>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion> */}

                <Accordion
                  sx={{ backgroundColor: "#f7f3eb", boxShadow: "none", mb: 1 }}
                  className="redeem"
                  defaultExpanded
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon color="error" />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      borderBottom: "1px solid #E4E4E4",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <h5>How to Redeem</h5>
                      <p
                        style={{
                          fontSize: "12px",
                          fontWeight: "300",
                          lineHeight: "12px",
                          color: "#1D1D1B",
                          display: "block",
                        }}
                      >
                        Collect your rewards within 14 days of activating the
                        voucher
                      </p>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{ paddingTop: "16px", paddingBottom: "16px" }}
                  >
                    <div style={{ position: "relative" }}>
                      <img
                        src={LineIcon}
                        alt="line icon"
                        style={{
                          position: "absolute",
                          left: "22px",
                          height: "100%",
                        }}
                      />
                      <div className="redeem-detail">
                        <img src={RedeemIcon} alt="redeem icon" />
                        <div>
                          <h6>Select Offer</h6>
                          <p>Choose your favourite vouchers</p>
                        </div>
                      </div>
                      <div
                        className="redeem-detail"
                        style={{ margin: "32px 0" }}
                      >
                        <img src={RedeemIcon} alt="redeem icon" />
                        <div>
                          <h6>Redeem Offer</h6>
                          <p>Activate your selected vouchers</p>
                        </div>
                      </div>
                      <div className="redeem-detail">
                        <img src={RedeemIcon} alt="redeem icon" />
                        <div>
                          <h6>Claim Offer</h6>
                          <p>
                            Claim the voucher copy at the concierge between 12
                            PM - 8 PM
                          </p>
                        </div>
                      </div>
                    </div>
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  sx={{ backgroundColor: "#f7f3eb", boxShadow: "none", mb: 1 }}
                  defaultExpanded
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon color="error" />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ borderBottom: "1px solid #E4E4E4" }}
                  >
                    <h5>Terms & Conditions</h5>
                  </AccordionSummary>
                  <AccordionDetails>
                    {termsAndConditionData?.split("\n")?.map((line, index) => (
                      <p key={index}>{line}</p>
                    ))}
                  </AccordionDetails>
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed-btn">
        <button
          onClick={() => {
            if (allowanceGroup?.blocked) return;
            handleIssueReward();
          }}
          disabled={Boolean(allowanceGroup?.blocked) || issueRewardLoading}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Activate Offer {issueRewardLoading ? <Spinner /> : null}
        </button>
      </div>
      <Footer />
    </div>
  );
};

export default OfferPage;
